import { render, staticRenderFns } from "./OrganisationSwitch.vue?vue&type=template&id=4b689e17&"
import script from "./OrganisationSwitch.vue?vue&type=script&lang=js&"
export * from "./OrganisationSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports